export default __webpack_public_path__ + "static/media/virtual_assistant.0a441abb.jpg";